import { AuthHelper } from "./auth-helper";
import { IAuthConfig, IAuthRoute } from "./interfaces";

export enum TokenStorage {
  SESSION_STORAGE,
  LOCAL_STORAGE
}

export const AUTH_CONFIG_DEFAULTS: IAuthConfig = {
    TokenName: "token",
    RefreshTokenName: "refresh_token",
    HeaderName: "Authorization",
    HeaderPrefix: "Bearer",
    NoJwtError: false,
    TokenStorage: TokenStorage.LOCAL_STORAGE
  },
  AUTH_ROUTE_DEFAULTS: IAuthRoute = {
    LoginSegment: "Account/Login",
    RegisterSegment: "Account/Register",
    LogOutSegment: "Account/Logout",
    RefreshSegment: "Account/Refresh",
    ChangePasswordSegment: "Account/ChangePassword",
    ResetPasswordSegment: "Account/ResetPassword",
    ToogleDisabledSegment: "Account/ToogleDisabled",
    LoginUrl: "/login",
    ChangePasswordUrl: "/change-password"
  };

export function tokenNotExpired(tokenName?: string, jwt?: string) {
  if (!tokenName) {
    tokenName = AUTH_CONFIG_DEFAULTS.TokenName;
  }

  const token =
    jwt || sessionStorage.getItem(tokenName) || localStorage.getItem(tokenName);

  const jwtHelper = new AuthHelper();

  return token != null && !jwtHelper.isTokenExpired(token);
}
